"use client";

import { useProducts } from "@/hooks/use-async";
import Link from "next/link";
import { MainLayout } from "@/components/layout";

export default function ProductsPage() {
  const { products, loading, error } = useProducts();

  if (loading) {
    return (
      <MainLayout>
        <div className="text-center py-12">Loading products...</div>
      </MainLayout>
    );
  }

  if (error) {
    return (
      <MainLayout>
        <div className="text-center py-12 text-red-600">
          Error: {error.message}
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2">Products</h1>
        <p className="text-gray-600">Browse all available products</p>
      </div>

      {products.length === 0 ? (
        <div className="text-center py-12 text-gray-600">
          No products available
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product: any) => (
            <Link key={product.id} href={`/products/${product.id}`}>
              <div className="nc-box-has-hover rounded-lg overflow-hidden cursor-pointer">
                <div className="bg-gray-200 h-48 flex items-center justify-center">
                  {product.media && product.media.length > 0 ? (
                    // eslint-disable-next-line @next/next/no-img-element
                    <img
                      src={product.media[0].media_url}
                      alt={product.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <span className="text-gray-400">No image</span>
                  )}
                </div>
                <div className="p-4">
                  <h2 className="text-lg font-semibold mb-2">{product.name}</h2>
                  <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                    {product.description || "No description"}
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-xl font-bold text-green-600">
                      ${product.price}
                    </span>
                    {product.rating_average && (
                      <span className="text-sm text-yellow-500">
                        ⭐ {product.rating_average.toFixed(1)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </MainLayout>
  );
}
